import { createSlice } from "@reduxjs/toolkit";

const recordSlice = createSlice({
    name: "records",
    initialState: {
        records: []
    },
    reducers: {
        setRecords: (state, action) => {
            state.records = action.payload;
        },
    },
});

export const { setRecords } = recordSlice.actions;

export default recordSlice.reducer;
